import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppointmentDispatchTypes, useAppointmentDispatch } from '../../context/Appointment/appointment';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { CTAButton } from '../../controls/ButtonBase';
import { useLocalization } from '../../context/Localization/localization';
import { Heading } from '../../controls/Heading/Heading';
import { ScrollableBody } from '../Layout/ScrollableBody';
import { AppRoutePaths, AppointmentRoutePaths, PathName } from '../../helpers/Routes';
import { GMButtonGroup } from '../../controls/ButtonGroup';
import { GMRoundedIcon, GMSizedIcon } from '../../controls/Icon';

export interface WelcomeProps {
    appointmentLookup: () => void;
    newAppointment: () => void;
}

export const Welcome: React.FC<WelcomeProps> = React.memo((props) => {
    const Localization = useLocalization();
    const kiosk = useKioskState();
    const navigate = useNavigate();
    const appointmentDispatch = useAppointmentDispatch();

    React.useEffect(() => {
        appointmentDispatch({ type: AppointmentDispatchTypes.RemoveAppointment });
    }, [appointmentDispatch]);

    return (
        <ScrollableBody
            heading={
                <Heading
                    primaryHeading={Localization.formatString(Localization.WelcomeToDealership, kiosk.dealer.name || '') as string}
                    secondaryHeading={Localization.DoYouHaveAnAppointment}
                    roundedIcon={
                        <GMRoundedIcon roundedBackgroundSize={'large'} themeType={'secondary'}>
                            <GMSizedIcon
                                iconType={'Profile'}
                                iconSize={'extraLarge'}
                                ariaLabel={Localization.ProfileIcon}
                            />
                        </GMRoundedIcon>
                    }
                    showMustache
                />
            }
            proceedButtons={
                <GMButtonGroup
                    alignment={'center'}
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={props.appointmentLookup}
                                label={Localization.YesIDo}
                                title={Localization.ClickToSearchForAppointment}
                                kioskOptions={{ square: true }}
                                id={Localization.ClickToSearchForAppointment}
                                ariaLabel={Localization.ClickToSearchForAppointment}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={() => {
                                    navigate(PathName(AppRoutePaths.Appointment, AppointmentRoutePaths.Customer));
                                    appointmentDispatch({
                                        type: AppointmentDispatchTypes.HasAppointment,
                                        payload: false,
                                    });
                                    props.newAppointment();
                                }}
                                label={Localization.NoIDoNot}
                                title={Localization.ClickToProceedNewAppointment}
                                kioskOptions={{
                                    squareOptions: {
                                        roundedIcon: (
                                            <GMRoundedIcon
                                                themeType={'primary'}
                                                allowInvertedPrimary
                                                roundedBackgroundSize={'large'}
                                            >
                                                <GMSizedIcon iconSize={'custom'} iconType={'No'} />
                                            </GMRoundedIcon>
                                        ),
                                    },
                                    square: true,
                                }}
                                id={Localization.ClickToProceedNewAppointment}
                                ariaLabel={Localization.ClickToProceedNewAppointment}
                            />
                        ),
                    ]}
                />
            }
            unsetButtons
        />
    );
});
